module.exports = __webpack_public_path__ + "static/media/ImageSix.fd99ec59.jpg";